import React from 'react';
import styles from './CancellationCheckbox.module.css';

interface CancellationCheckboxProps {
    label: string;
    checked: boolean;
    onChange: () => void;
    name: string;
}

export const CancellationCheckbox = ({ label, checked, onChange, name }: CancellationCheckboxProps) => {
    return (
        <label className={`${styles.wrapper} ${checked ? styles.checked : ''}`}>
            <input
                type='checkbox'
                name={name}
                checked={checked}
                onChange={onChange}
                className={styles.hiddenCheckbox}
            />
            <span className={styles.checkboxIcon} />
            <span className={styles.label}>{label}</span>
        </label>
    );
};
